module.exports = __webpack_public_path__ + "img/lotus-led-lights.05bd0e9d.png";